import { InfoCircleOutlined } from "@ant-design/icons";
import { Card, Col, Row, Slider, Tooltip, Typography } from "antd";
import { Bar } from "react-chartjs-2";
import { useMemo, useState } from "react";

const { Text } = Typography;
const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: false,
    },
  },
  scales: {
    x: {
      title: {
        display: true,
        text: "Zonas",
      },
      grid: {
        display: false,
      },
    },
    y: {
      title: {
        display: true,
        text: "Tempo de Atenção (min)",
      },
      ticks: {
        callback: (value) =>
          Number(value || 0).toLocaleString("pt-BR", {
            maximumFractionDigits: 1,
          }),
      },
    },
  },
};

export default function BarChartWrapper({ data, maxZones, isLoading }) {
  const [selectedNumberZones, setSelectedNumberZones] = useState(null);

  const formattedData = useMemo(() => {
    if (!selectedNumberZones) {
      return data;
    }

    if (!data) {
      return { labels: [], datasets: [] };
    }

    const { labels, datasets } = data;

    const dataToFormat = datasets[0].data;
    const filteredByZones = labels
      .slice(0, selectedNumberZones)
      .map((label, index) => ({
        label,
        data: dataToFormat[index],
      }));

    filteredByZones.sort((a, b) => b.data - a.data);

    const filteredLabels = filteredByZones.map((item) => item.label);
    const filteredDataFinal = filteredByZones.map((item) => item.data);

    return {
      labels: filteredLabels,
      datasets: [
        {
          ...datasets[0],
          data: filteredDataFinal,
        },
      ],
    };
  }, [data, selectedNumberZones]);

  return (
    <Card
      title={
        <span>
          {"Tempo de Atenção por Zona "}
          <Tooltip title="Inclui apenas detecções de clientes">
            <InfoCircleOutlined style={{ fontSize: 13, color: "#9ca3af" }} />
          </Tooltip>
        </span>
      }
      align="center"
      style={{
        width: "85%",
      }}
      styles={{
        header: {
          backgroundColor: "var(--ouran-card-header-bg)",
        },
      }}
      loading={isLoading}>
      <Row gutter={[16, 8]} className="ouran-chart-slider-row">
        <Col xs={24} sm={12} style={{ textAlign: "right" }}>
          <Text strong style={{ marginRight: 10 }}>
            {"Escolha o número de zonas a serem mostradas:"}
          </Text>
        </Col>
        <Col xs={24} sm={12}>
          <Slider
            defaultValue={maxZones}
            min={1}
            max={maxZones}
            marks={
              maxZones
                ? {
                    1: "1",
                    [Math.floor(maxZones / 2) || 1]:
                      `${Math.floor(maxZones / 2) || 1}`,
                    [maxZones]: `${maxZones}`,
                  }
                : { 1: "1" }
            }
            style={{ width: "100%", maxWidth: "200px" }}
            onChangeComplete={(value) => setSelectedNumberZones(value)}
          />
        </Col>
      </Row>
      {formattedData && <Bar data={formattedData} options={options} />}
    </Card>
  );
}
